/* Maps raw extraction/NER field codes (INVOICE_NUMBER, GPE, MONETARY…) to
   plain, real-world names a non-technical user understands. Used wherever a
   field label is shown to the user (detail panel, correction chips, add-field).
   Unknown codes fall back to Title Case of the code. */

const FRIENDLY_FIELD_NAMES: Record<string, string> = {
  // Invoice fields
  INVOICE_NUMBER: 'Invoice number',
  INVOICE_DATE: 'Invoice date',
  DUE_DATE: 'Due date',
  ISSUE_DATE: 'Issue date',
  PO_NUMBER: 'PO number',
  ORDER_NUMBER: 'Order number',
  // Parties
  SELLER: 'Seller',
  SELLER_NAME: 'Seller',
  SELLER_ADDRESS: 'Seller address',
  SELLER_EMAIL: 'Seller email',
  SELLER_PHONE: 'Seller phone',
  SELLER_TAX_ID: 'Seller tax ID',
  SELLER_VAT_ID: 'Seller VAT ID',
  BUYER: 'Buyer',
  BUYER_NAME: 'Buyer',
  BUYER_ADDRESS: 'Buyer address',
  BUYER_EMAIL: 'Buyer email',
  BUYER_PHONE: 'Buyer phone',
  BUYER_TAX_ID: 'Buyer tax ID',
  BUYER_VAT_ID: 'Buyer VAT ID',
  VENDOR: 'Seller',
  CLIENT: 'Buyer',
  REFERENCE_NUMBER: 'Reference number',
  SHIPPING_COST: 'Shipping cost',
  NOTES: 'Notes',
  // Tax / IDs
  TAX_ID: 'Tax ID',
  VAT_ID: 'VAT ID',
  NIP: 'Tax ID (NIP)',
  // Money
  TOTAL_AMOUNT: 'Total amount',
  INVOICE_AMOUNT: 'Total amount',
  SUBTOTAL: 'Subtotal',
  TAX_AMOUNT: 'Tax',
  TAX_RATE: 'Tax rate',
  CURRENCY: 'Currency',
  MONEY: 'Amount',
  MONETARY: 'Amount',
  UNIT_PRICE: 'Unit price',
  QUANTITY: 'Quantity',
  LINE_ITEM: 'Line item',
  DISCOUNT: 'Discount',
  // Payment
  IBAN: 'Bank account (IBAN)',
  BANK_ACCOUNT: 'Bank account',
  PAYMENT_TERMS: 'Payment terms',
  PAYMENT_METHOD: 'Payment method',
  // Generic NER types
  ORG: 'Organization',
  ORGANIZATION: 'Organization',
  PERSON: 'Person',
  PERSON_TITLE: 'Job title',
  GPE: 'Location',
  LOC: 'Location',
  LOCATION: 'Location',
  ADDRESS: 'Address',
  DATE: 'Date',
  EMAIL: 'Email',
  PHONE: 'Phone',
  URL: 'Website',
};

/** Plain, real-world name for a raw field/entity code. */
export function friendlyFieldName(label: string | undefined | null): string {
  if (!label) return 'Field';
  const key = label.trim().toUpperCase();
  if (FRIENDLY_FIELD_NAMES[key]) return FRIENDLY_FIELD_NAMES[key];
  // Fallback: turn SOME_RAW_CODE into "Some raw code"
  const words = label.replace(/[_-]+/g, ' ').trim().toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
